import { TableItem } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IAccountMutationForm } from 'services/accounts/types';
import { useGetSettlementMethods } from 'services/enums';

export const settlementMethodInitialValues = {
  settlementMethodName: '',
  available: true,
};

const AccountSettlementMethods = () => {
  const {
    values,
    status,
    setFieldValue,
    initialValues,
  }: IFormikContextType<IAccountMutationForm> =
    useFormikContext<IAccountMutationForm>();

  const { t } = useTranslation();
  const settlementMethods = useGetSettlementMethods();

  useEffect(() => {
    if (
      settlementMethods.data?.length !==
      values.availableSettlementMethods.length
    ) {
      setFieldValue(
        'availableSettlementMethods',
        settlementMethods.data?.map((settlementMethod, index) => ({
          settlementMethodName: settlementMethod.name,
          available:
            initialValues.availableSettlementMethods.find(
              a => a.settlementMethodId === settlementMethod.id && a.available,
            )?.available ?? false,
          settlementMethodId: settlementMethod.id,
        })) ?? [],
      );
    }
  }, [
    settlementMethods.data?.length,
    initialValues.availableSettlementMethods.length,
    values.availableSettlementMethods,
  ]);

  return (
    <Table
      id={'AccountSettlementMethods2'}
      size='compact'
      data={{
        nodes: values.availableSettlementMethods.map((s, index) => ({
          ...s,
          id: index,
        })),
      }}
      loading={settlementMethods.isLoading}
      columns={[
        {
          label: 'Settlement method',
          renderCell: ({ settlementMethodName }) => (
            <TableItem justifyPosition='start'>
              <TableItem.Text text={settlementMethodName} />
            </TableItem>
          ),
          resize: true,
        },
        {
          label: t('input.label.available'),
          renderCell: ({ available, id }) => (
            <TableItem justifyPosition='start'>
              <FormInput.Checkbox
                name={`availableSettlementMethods[${id}].available`}
                label={available ? t('input.label.available') : 'Not available'}
              />
            </TableItem>
          ),
        },
      ]}
    />
  );
};

export default AccountSettlementMethods;
